import { Prop, Vue } from "vue-property-decorator";

export default class IstFormBase extends Vue {
  @Prop({ default: null })
  label!: string | null;

  getLabel(): string | undefined {
    if (!this.label || this.label === "") {
      return undefined;
    }
    const s: string = this.label.charAt(0).toUpperCase() + this.label.substring(1).toLowerCase();
    return s ? s : undefined;
  }
}
